import groq from "groq"

export const groqProductProjection = () => groq`
    categories[]->{
        ...,
        parentCategory->
    },
    vendor->,
    similarProducts[]->{
        ...,
        categories[]->{
            ...,
            parentCategory->
        },
        vendor->,
        "attributes": attributeValues[] {
            attribute-> {
                id,
                key,
                type,
            },
            value
        },
        "images": attachments[type=="img"] {...,asset->},
    },
    variants[]->{
        ...,
        articleMainGroup-> {
            "id": _id,
            key,
            name,
        },
        articleGroup-> {
            "id": _id,
            key,
            name,
        },
        "attributes": attributeValues[] {
            attribute-> {
                id,
                key,
                type,
            },
            value
        },
    },
    "id":_id,
    "attributes": attributeValues[] {
        attribute-> {
            id,
            key,
            type,
        },
        value
    },
    "images": attachments[type=="img"] {...,asset->},
    "technicalManuals":attachments[type=="tm"] {...,asset->},
    "sdbManuals":attachments[type=="sdb"] {...,asset->},
    "zertManuals":attachments[type=="zert"] {...,asset->},
`

export const groqShortProductProjection = () => groq`
    categories[]->{
        ...,
        parentCategory->
    },
    vendor->,
    "id":_id,
    variants[]->{
        articleMainGroup-> {
            "id": _id,
            key,
            name,
        },
        "attributes": attributeValues[] {
            attribute-> {
                id,
                key,
                type,
            },
            value
        },
    },
    "attributes": attributeValues[] {
        attribute-> {
            id,
            key,
            type,
        },
        value
    },
    "images": attachments[type=="img"] {...,asset->},
`
